"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var ProductValidationService = /** @class */ (function () {
    function ProductValidationService() {
        this.schemaForGetProductBySlug = joi_1.default.object().keys({
            slug: joi_1.default.string().required(),
            relatedChildren: joi_1.default.boolean().optional(),
            sameProducts: joi_1.default.boolean().optional(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetRelatedProducts = joi_1.default.object().keys({
            slug: joi_1.default.string().required(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetSameProducts = joi_1.default.object().keys({
            slug: joi_1.default.string().required(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetRecentlyProducts = joi_1.default.object().keys({
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetProductsByCategory = joi_1.default.object().keys({
            categorySlug: joi_1.default.string().required(),
            filterSlugs: joi_1.default.array().items(joi_1.default.string()).optional(),
            filters: joi_1.default.array().items(joi_1.default.string()).optional(),
            page: joi_1.default.number().optional(),
            perPage: joi_1.default.number().optional(),
            sort: joi_1.default.string().optional(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetProductsByPromotion = joi_1.default.object().keys({
            promotionSlug: joi_1.default.string().required(),
            filterSlugs: joi_1.default.array().items(joi_1.default.string()).optional(),
            filters: joi_1.default.array().items(joi_1.default.string()).optional(),
            page: joi_1.default.number().optional(),
            perPage: joi_1.default.number().optional(),
            sort: joi_1.default.string().optional(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetProductsByBrand = joi_1.default.object().keys({
            brandSlug: joi_1.default.string().required(),
            filterSlugs: joi_1.default.array().items(joi_1.default.string()).optional(),
            filters: joi_1.default.array().items(joi_1.default.string()).optional(),
            page: joi_1.default.number().optional(),
            perPage: joi_1.default.number().optional(),
            sort: joi_1.default.string().optional(),
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForGetProductsBySet = joi_1.default.object().keys({
            setSlug: joi_1.default.string().required(),
            filterSlugs: joi_1.default.array().items(joi_1.default.string()).optional(),
            filters: joi_1.default.array().items(joi_1.default.string()).optional(),
            page: joi_1.default.number().optional(),
            perPage: joi_1.default.number().optional(),
            sort: joi_1.default.string().optional(),
            extensions: joi_1.default.array().items().optional()
        });
    }
    ProductValidationService.prototype.getProductBySlugData = function (data) {
        var error = this.schemaForGetProductBySlug.validate(data).error;
        // debug
        console.debug('Validating get product by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getRelatedProducts = function (data) {
        var error = this.schemaForGetRelatedProducts.validate(data).error;
        // debug
        console.debug('Validating get product by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getSameProducts = function (data) {
        var error = this.schemaForGetSameProducts.validate(data).error;
        // debug
        console.debug('Validating get product by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getRecentlyProducts = function (data) {
        var error = this.schemaForGetRecentlyProducts.validate(data).error;
        // debug
        console.debug('Validating get product by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getProductsByCategory = function (data) {
        var error = this.schemaForGetProductsByCategory.validate(data).error;
        // debug
        console.debug('Validating get products by category data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getProductsByPromotion = function (data) {
        var error = this.schemaForGetProductsByPromotion.validate(data).error;
        // debug
        console.debug('Validating get products by promotion data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getProductsByBrand = function (data) {
        var error = this.schemaForGetProductsByBrand.validate(data).error;
        // debug
        console.debug('Validating get products by promotion data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    ProductValidationService.prototype.getProductsBySet = function (data) {
        var error = this.schemaForGetProductsBySet.validate(data).error;
        // debug
        console.debug('Validating get products by set data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return ProductValidationService;
}());
exports.ProductValidationService = ProductValidationService;
//# sourceMappingURL=ProductValidationService.js.map